<template>
  <v-card style="width: 75vw; margin: 32px auto">
    <div class="d-flex align-start" style="padding: 24px; gap: 12px">
      <h2 class="mr-auto">Issues</h2>
      <ExportButton
        v-if="isadministrator || issuperadministrator"
        :table-type="'issues'"
        :export-message="'Export List'"
      ></ExportButton>
      <Tooltip :message="tooltipMessage"></Tooltip>
    </div>
    <v-row class="d-flex align-center mx-5 mb-3">
      <v-col cols="8">
        <v-text-field v-model="rawSearch" label="Search" hide-details clearable></v-text-field>
      </v-col>
      <v-col>
        <v-checkbox
          v-model="showclosed"
          label="Closed Issues"
          @update:model-value="triggerLoadIssues"
          hide-details
          color="green-lighten-1"
        >
        </v-checkbox>
      </v-col>
      <v-col>
        <v-checkbox
          label="My issues"
          v-model="showUserIssues"
          @update:model-value="triggerLoadIssues"
          color="green-lighten-1"
          hide-details
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-data-table-server
      :search="search"
      :headers="headers"
      :items="tableItems"
      :items-length="totalIssueRows"
      :items-per-page-options="footerProps['items-per-page-options']"
      :items-per-page="issueItemsPerPage"
      item-value="id"
      class="elevation-1"
      @update:options="loadIssues"
      @update:sort-by="updatingIssueSortBy"
      @update:page="updatingIssuePage"
      @update:items-per-page="updatingIssueItemsPerPage"
      ref="issueServerDataTable"
    >
      <template v-slot:item="{ item }">
        <tr
          @click="showdetailsdialog(item)"
          class="table-hover"
          :class="{ 'last-selected-row': idOfLastSelectedRow === item.id }"
        >
          <td class="row-text-no-wrap">
            {{ item.displayType }}
          </td>
          <td class="row-text-no-wrap">
            {{ item.name }}
          </td>
          <td class="row-text-no-wrap">
            {{ item.qrid }}
          </td>
          <td class="row-text-no-wrap">
            {{ item.description }}
          </td>
          <td class="row-text-no-wrap">
            {{ item.location }}
          </td>
          <td class="row-text-no-wrap">
            {{ item.created }}
          </td>
          <td></td>
          <td>
            <div style="display: flex; justify-content: center">
              <StatusButton :issue-item="item" @set-status="setStatus" @show-status-dialog="showstatusdialog">
              </StatusButton>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table-server>
    <v-dialog v-model="detailsdialog" max-width="75vw" min-height="75vh">
      <v-card>
        <div class="d-flex">
          <v-card-title>
            <span class="headline">
              {{ getReportType }} - {{ selecteditem.displayType }} - {{ selecteditem.name }} - {{ selecteditem.created }}
              </span
            >
          </v-card-title>
        </div>
        <v-tabs v-model="issueDetailsTab" background-color="transparent" color="black" left>
          <v-tab value="details">Details</v-tab>
          <v-tab v-if="organizationAllowsInternalLog" value="issueLog">Notes and log</v-tab>
          <v-tab v-if="!!currentItemCoords && !!locationImageUrl" @click="showMapComponent" value="map">Map</v-tab>
        </v-tabs>
        <v-card-text>
          <v-tabs-window v-model="issueDetailsTab">
            <v-tabs-window-item value="details">
              <v-row>
                <v-col class="detail-text" style="overflow-y: auto">
                  <v-sheet
                    class="ma-4"
                    elevation="5"
                    rounded="lg"
                    style="display: grid; grid-template-columns: 70% 30%"
                  >
                    <v-container>
                      <v-row
                        v-for="(issueValue, issueKey) in selectedItemDetails"
                        :key="issueKey"
                        class="my-2"
                        no-gutters
                      >
                        <div style="width: 120px">
                          <p v-if="issueKey != 'skip'" class="ma-0">{{ issueKey }}:</p>
                          <p v-else class="mb-6"></p>
                        </div>
                        <v-col align-self="start">
                          <p class="ma-0">{{ issueValue }}</p>
                        </v-col>
                      </v-row>
                    </v-container>
                    <div class="ml-auto mt-6 mr-4">
                      <StatusButton
                        :issue-item="selecteditem"
                        @set-status="setStatus"
                        @show-status-dialog="showstatusdialog"
                      >
                      </StatusButton>
                    </div>
                  </v-sheet>
                </v-col>
                <v-col>
                  <a :href="imageUrl" target="_blank"><img v-if="selecteditem.picturename" class="issue-image" :src="imageUrl" @error="refreshImageData" :alt="selecteditem.picturename" /></a>
                </v-col>
              </v-row>
            </v-tabs-window-item>
            <v-tabs-window-item v-if="organizationAllowsInternalLog" value="issueLog">
              <InternalLog :issueLogs="this.issueLogs" :selecteditem="this.selecteditem" @issue-logs-updated="loadIssueLogs" ref="internalLogComponent"></InternalLog>
            </v-tabs-window-item>
            <v-tabs-window-item value="map">
              <div v-if="detailsdialog" class="map-area-general">
                <MapComponent v-if="detailsdialog" :qrId="-1" :name="currentItemLocationImageName" :imgUrl="locationImageUrl" :qrs="mapMarker" />
              </div>
            </v-tabs-window-item>
          </v-tabs-window>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile outlined class="mb-3" @click="detailsdialog = false"
            ><v-icon small class="py-2 mr-1">mdi-close</v-icon> Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { HTTP } from "@/plugins/backendAPI";
import { mapGetters } from "vuex";
import MapComponent from "../../components/MapComponent.vue";
// import { EventBus } from "@/store/event-bus.js";
import Tooltip from "../../components/HelpTooltip.vue";
import StatusButton from "../../components/StatusButton.vue";
import ExportButton from "../../components/ExportButton.vue";
import { formatUtcDateTimeToLocal } from "../../helpers/formattedDateTime.js";
import InternalLog from "../../components/InternalLog.vue";

export default {
  components: {
    MapComponent,
    Tooltip,
    StatusButton,
    ExportButton,
    InternalLog
  },
  data() {
    return {
      // Issue data table related
      // ================================
      issueItemsPerPage: 25,
      issuePage: 1,
      issueSortBy: [],
      totalIssueRows: 0,
      tableItems: [],
      rawSearch: this.$route.query.inventoryId,
      search: null,
      showclosed: this.$route.query.showClosed === "true" ? true : false,
      footerProps: { "items-per-page-options": [25, 50] },
      showUserIssues: false,
      // ================================

      enableEscClear: true,
      headers: [
        { title: "Report type", key: "type", width: 150 },
        { title: "Responsible", key: "name", width: 150 },
        { title: "QR-Id", key: "qrid", width: 100 },
        { title: "QR-Code", key: "description", width: 150 },
        { title: "Location", key: "location", width: 150 },
        { title: "Created", key: "created", width: 150 },
        { title: "", key: "", sortable: false },
        { title: "Status", key: "status", width: 100 },
      ],
      issueDetailsTab: null,
      editedItem: {},
      searchedItems: [],
      inventorytypeItems: [],
      inventorytypeSelected: null,
      selecteditem: {},
      selectedItemDetails: {},
      idOfLastSelectedRow: 0,
      mapMarker: null,
      tooltipMessage: [
        "Issues",
        "On this page, you can manage your issues/reports. Click on an issue to view its details. Change the status by clicking on the current status and selecting a new one. All contents of the listed issues are searchable, including the reporter's email address, comments, or device names.",
      ],
      detailsdialog: false,
      showToolTipDialog: false,

      sortHandler: {},
      sortOptions: {
        sortBy: [],
        sortDesc: [],
      },

      showMap: false,
      currentItemCoords: "",
      currentItemImageName: "",
      imageUrl: null,
      currentItemLocationImageName: "",
      locationImageUrl: null,

      issueLogs: [],
    };
  },
  computed: {
    ...mapGetters([
      "sort",
      "workspaceid",
      "workspaceitems",
      "organizationid",
      "username",
      "isadministrator",
      "issuperadministrator",
      "ismyissuestoggled",
      "loading",
      "organizationitems",
    ]),
    getReportType() {
      if (this.selecteditem.type === "Contact request" || this.selecteditem.type === "Feedback")
        return this.selecteditem.type;
      return "Fault report";
    },
    organizationAllowsInternalLog() {
      const organization = this.organizationitems.find(org => org.id === this.organizationid);
      return organization ? organization.useInternalLog : false;
    },
  },
  created() {
    this.showUserIssues = this.ismyissuestoggled;
    this.sortOptions = this.sort.issueSort || this.sortOptions;
    this.loadIssueLogs();
  },
  mounted() {
    document.addEventListener("keydown", this.clearSearchEsc);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.clearSearchEsc);
  },
  watch: {
    sortHandler: {
      deep: true,
      handler(obj) {
        const objSort = { sortBy: obj.sortBy, sortDesc: obj.sortDesc };

        if (JSON.stringify(objSort) !== JSON.stringify(this.sortOptions)) {
          const newObj = this.sort;
          newObj.issueSort = objSort;
          this.$store.dispatch("updateSort", newObj);
        }
      },
    },
    workspaceid(value) {
      if (value === -1) {
        this.tableItems = [];
        this.totalIssueRows = 0;
        return;
      }
      this.triggerLoadIssues();
      this.loadIssueLogs();
    },
    rawSearch(value, currentValue) {
      setTimeout(() => {
        if (
          (this.rawSearch === value && value?.length >= 3) ||
          (this.rawSearch === value && value?.length < currentValue?.length) ||
          !value
        ) {
          this.search = value;
        }
      }, 350);
    },
    showUserIssues(updatedValue) {
      this.$store.dispatch("saveMyIssuesToggle", updatedValue);
    },
    detailsdialog(val) {
      if (val) {
        this.enableEscClear = false;
        this.issueDetailsTab = null;
      }
      if (!val) {
        this.showMap = false;
        this.currentItemCoords = "";
        this.currentItemImageName = "";
        if (this.$refs.internalLogComponent) {
          this.$refs.internalLogComponent.resetIssueLogEdits();
        }
        setTimeout(() => { }, 100);
      }
    },
    issueSortBy: {
      deep: true,
      handler(value) {
        console.log(value);
      },
    },
  },
  methods: {
    updatingIssueSortBy(value) {
      this.issueSortBy = value;
    },
    updatingIssuePage(value) {
      this.issuePage = value;
    },
    updatingIssueItemsPerPage(value) {
      this.issueItemsPerPage = value;
    },
    triggerLoadIssues() {
      this.$nextTick(() => {
        if (!this.$refs["issueServerDataTable"]) {
          this.loadIssues({ page: 1, itemsPerPage: 25, sortBy: [] });
          return;
        }
        const page = this.issuePage === 0 ? 1 : this.issuePage;
        const itemsPerPage = this.issueItemsPerPage;
        const sortBy = this.issueSortBy;
        this.loadIssues({ page, itemsPerPage, sortBy });
      });
    },
    loadIssues({ page = 1, itemsPerPage = 25, sortBy = [], search = null }) {
      if (this.workspaceid === -1) {
        return;
      }
      if (sortBy.length === 1 && sortBy[0] === "") {
        sortBy = [];
      }
      this.$store.dispatch("setLoading", true);
      HTTP.post(
        `/issues/get?pagination=true&show-closed=${this.showclosed}&sort-by-user=${this.showUserIssues}&workspace-id=${this.workspaceid}`,
        { page, itemsPerPage, sortBy, search }
      )
        .then((response) => {
          this.tableItems = response.data.mappedIssues;
          this.tableItems = this.tableItems.map(item => ({
            ...item,
            created: formatUtcDateTimeToLocal(item.created)
          }));
          this.totalIssueRows = response.data.totalIssues;
        })
        .catch(() => {
          this.tableItems = [];
          this.totalIssueRows = 0;
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    loadIssueLogs(){
      if (this.workspaceid === -1){
        return;
      }
      this.$store.dispatch("setLoading", true);
      HTTP.get(`/issuelogs/get/by-workspace-id/${this.workspaceid}?organizationId=${this.organizationid}`)
        .then((response) => {
          this.issueLogs = response.data;
          this.issueLogs = this.issueLogs.map(log => ({
            ...log,
            createdDate: formatUtcDateTimeToLocal(log.createdDate),
            deletedDate: log.deletedDate ? formatUtcDateTimeToLocal(log.deletedDate) : null,
            versions: log.versions ? log.versions.map(version => ({
              ...version,
              createdDate: formatUtcDateTimeToLocal(version.createdDate),
              deletedDate: version.deletedDate ? formatUtcDateTimeToLocal(version.deletedDate) : null,
            })) : []
          }));
        })
        .catch(() => {
          this.issueLogs = [];
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    showstatusdialog(item) {
      this.selecteditem = item;
    },
    showToolTip() {
      if (this.showToolTipDialog == true) {
        this.showToolTipDialog = false;
      } else {
        this.showToolTipDialog = true;
      }
    },
    getSelectedDetails(item) {
      this.itemDate = new Date(item.created);
      this.differentItemDate = formatUtcDateTimeToLocal(this.itemDate);
      if (item.type === "Contact request") {
        this.selectedItemDetails = {
          "QR Category": item.qrCategory,
          QRID: item.qrid,
          Created: this.differentItemDate,
          Description: item.description,
          Location: item.location,
          Responsible: item.name,
          skip: "",
          "Issuer e-mail": item.issuerEmail,
          Message: item.message,
          //"Created": `${this.itemDate.getFullYear()}-${this.itemDate.getMonth() + 1}-${this.itemDate.getDate()} ${this.itemDate.getHours()}:${this.itemDate.getMinutes()}`,
        };
      } else {
        this.selectedItemDetails = {
          "QR Category": item.qrCategory,
          "Inventory Type": item.inventoryType,
          "Custom Type Description": item.aliasTypeDescription,
          Inventory: item.inventoryDescription,
          QRID: item.qrid,
          Created: this.differentItemDate,
          Description: item.description,
          Location: item.location,
          Responsible: item.name,
          skip: "",
          "Issuer e-mail": item.issuerEmail,
          Message: item.message,
          //"Created": `${this.itemDate.getFullYear()}-${this.itemDate.getMonth() + 1}-${this.itemDate.getDate()} ${this.itemDate.getHours()}:${this.itemDate.getMinutes()}`,
        };
      }
    },
    showMapComponent(e) {
      const value = e.target.innerText;
      if (value === "MAP") {
        setTimeout(() => {
          this.showMap = true;
        }, 100);
      }
    },
    getStatus(status) {
      switch (status) {
        case 0:
          return "red";
        case 1:
          return "orange";
        case 2:
          return "green";
      }
    },
    getStatustext(status) {
      switch (status) {
        case 0:
          return "Waiting";
        case 1:
          return "Ongoing";
        case 2:
          return "Closed";
      }
    },
    setStatus(status, issueItem) {
      const previousStatus = issueItem.status;
      issueItem.status = status;
      this.$store.dispatch("setLoading", true);
      HTTP.post("/issues/savestatus", {
        id: issueItem.id,
        type: issueItem.type,
        status: status,
      })
        .then(() => { this.loadIssueLogs(); })
        .catch((e) => {
          issueItem.status = previousStatus;
          this.$store.dispatch("showError", "Error when setting status: " + (e.response.data.message ?? e.response.data));
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    async showdetailsdialog(item) {
      this.selecteditem = item;
      this.idOfLastSelectedRow = item.id;
      this.mapMarker = [{ qrId: item.qrid, qrString: item.qrid, qrDescription: item.description, latLng: item.latLng }];
      this.getSelectedDetails(item);
      this.currentItemCoords = item.latLng === null ? "" : item.latLng;
      await this.getImageDeta(item.picturename);
      await this.getLocationImageDeta(item.locationImageId);
      this.detailsdialog = true;
    },
    async getImageDeta(imageName) {
      if (!imageName) {
        this.currentItemImageName = "";
        this.imageUrl = null;
        return;
      }
      this.$store.dispatch("setLoading", true);
      try {
        const response = await HTTP.get(`/image/getImageDataByName/${imageName}`);
        this.currentItemImageName = response.data.imageName;
        this.imageUrl = response.data.imageUrl;
      } catch (error) {
        this.currentItemImageName = "";
        this.imageUrl = null;
        //this.$store.dispatch("showError", "Error fetching image details: " + error.response.data);
      } finally {
        this.$store.dispatch("setLoading", false);
      }
    },
    async getLocationImageDeta(imageId) {
      if (!imageId) {
        this.currentItemLocationImageName = "";
        this.locationImageUrl = null;
        return;
      }
      this.$store.dispatch("setLoading", true);
      try {
        const response = await HTTP.get(`/image/getImageData/${imageId}`);
        this.currentItemLocationImageName = response.data.imageName;
        this.locationImageUrl = response.data.imageUrl;
      } catch (error) {
        this.currentItemLocationImageName = "";
        this.locationImageUrl = null;
        //this.$store.dispatch("showError", "Error fetching image details: " + error.response.data);
      } finally {
        this.$store.dispatch("setLoading", false);
      }
    },
    async refreshImageData() {
      if (this.selecteditem && this.selecteditem.picturename) {
        await this.getImageDeta(this.selecteditem.picturename);
      }

      if (this.selecteditem && this.selecteditem.locationImageId) {
        await this.getLocationImageDeta(this.selecteditem.locationImageId);
      }
    },
    filter(value, search, item) {
      return Object.values(item).some((prop) => {
        return String(prop).toLowerCase().includes(search.toLowerCase());
      });
    },
    clearSearchEsc(e) {
      if (e.keyCode === 27) {
        if (this.detailsdialog) {
          this.detailsdialog = false;
          return;
        }
        if (this.enableEscClear) this.search = "";
      }
    },
  },
};
</script>
